export interface Category {
  id: string;
  name: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { id: 'shoes', name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { id: 'hoodies', name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { id: 'tshirts', name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { id: 'jackets', name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-windy-line' },
  { id: 'pants', name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-walk-line' },
  { id: 'headwear', name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-line' },
  { id: 'sets', name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { id: 'underwear', name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-heart-line' },
  { id: 'jersey', name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shield-line' },
  { id: 'accessories', name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
  { id: 'bags', name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line' },
  { id: 'belts', name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { id: 'perfumes', name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { id: 'other', name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];